import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BellIcon } from "@heroicons/react/20/solid";
// const unfinished = true
const unfinished = false;

const NotificationButton = ({ unread }) => {
	const location = useLocation();
	const active = location.pathname.includes("notifications");

	const navigate = useNavigate();

	if (unfinished) return null;

	return (
		<div
			className={`btn btn-default pull-right relative`}
			type="button"
			onClick={() => {
				navigate("/notifications");
			}}
		>
			<BellIcon style={{ height: "1.5em", float: "left" }} />
			{!active && unread ? (
				<div
					className="absolute"
					style={{
						height: "0.75rem",
						width: "0.75rem",
						background: "#ea611c",
						borderRadius: "1rem",
						left: "2.75rem",
						top: "1.75rem",
					}}
				/>
			) : null}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const notificationList = state.notifications?.list || [];
	const integrationNotifications = state.notifications?.integrations || [];
	const notifications = [...notificationList, ...integrationNotifications];
	return {
		unread: !!notifications?.find((item) => !item.read),
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationButton);
